/**
 * Formatea un nombre completo del genoma para mostrarlo abreviado en el nodo del árbol.
 *
 * El backend envía el nombre en orden: "Apellido2 Apellido1 Nombre1 Nombre2 ..."
 * Esta función lo abrevia para que quepa en la tarjeta de 150px.
 *
 * Comportamiento:
 * - Si el nombre contiene '*' (enmascarado por restricción de acceso),
 *   retorna "******* ******* ******* *******".
 * - Si tiene 5+ partes (2 apellidos + 2 nombres + extra), muestra:
 *   "Nombre2 Nombre1 N2. Apellido2 A1." (iniciales en apellido1 y último nombre).
 * - Si tiene 3-4 partes, muestra:
 *   "Nombre1 N2. Apellido2 A1."
 * - Si tiene menos de 3 partes o es undefined, retorna '-'.
 *
 * @param name - Nombre completo desde el backend (ej: "GARCIA LOPEZ JUAN CARLOS")
 * @returns Nombre abreviado (ej: "CARLOS JUAN L. GARCIA G.") o máscara/placeholder
 *
 * @example
 * formatGenomeName("GARCIA LOPEZ JUAN CARLOS")  // "CARLOS JUAN L. GARCIA G."
 * formatGenomeName("G***IA LO**Z JU** CA***S")  // "******* ******* ******* *******"
 * formatGenomeName(undefined)                     // "-"
 */
export function formatGenomeName(name: string | undefined): string {
    if (name) {
        const parts = name.split(' ');
        if (parts.length >= 3) {
            if (name.includes('*')) {
                return `******* ******* ******* *******`;
            }
            parts.reverse();
            const firstName = parts.length > 4 ? `${parts[2]} ${parts[1]}` : parts[1];
            const secondName = parts[0][0] + '.';
            const lastName = parts[parts.length - 1];
            const secondLastName = parts[parts.length - 2][0] + '.';
            return `${firstName} ${secondName} ${lastName} ${secondLastName}`;
        }
    }
    return '-';
}
